// extracted by mini-css-extract-plugin
export default {"mainContainer":"BusinessMap_mainContainer__juGkk","map":"BusinessMap_map__H3QIg","wrongInfoContainer":"BusinessMap_wrongInfoContainer__xRhAt"};